import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Table, Spin, Select, DatePicker, Space, Form } from "antd";
import Button from "atoms/Button";
import moment from "moment";
import styled from "@emotion/styled";
import { utils, writeFileXLSX } from "xlsx";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getAllDepartmentList,
  getSelectedDepartmentId,
  getShiftTimeMaster,
  getUserList,
  getClientid,
  getUserInfo,
  getMenuList,
} from "redux/selectors";
import { CALL_API } from "common/API";
import {
  MONTH_LIST,
  REPORT_DURATION_TYPES,
  STATUS_CODE,
} from "common/Constants";
import {
  addDaysinDate,
  dateInDetail,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
  addMonthinDate,
} from "utils/Date";
import COLORS from "common/Colors";
import { concat, find, get, includes, orderBy, uniqBy } from "lodash";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import dayjs from "dayjs";

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
  }
  table {
    width: 100% !important;
  }
  a {
    color: #2d53da !important;
    :hover {
      color: #2d53da;
    }
    :active {
      color: #2d53da;
    }
  }
  .ant-table-cell {
    padding: 20px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }

  a {
    color: #2d53da !important;
  }
`;

const StyledApprovalSearchForm = styled(Form)`
  .ant-form-item-with-help {
    margin-bottom: 0px;
    .ant-form-item-explain-connected {
      display: none;
    }
  }
  .ant-form-item {
    display: inline-block;
  }
  .outer-form {
    margin-right: 0px;
  }
  .ant-select-selector {
    max-width: 180px;
    min-width: 180px;
    margin-bottom: 10px;
    width: 180px;
  }
  // .ant-btn.ant-btn-default.ant-dropdown-trigger.w-100.mb-3.custom-filter-btn {
  //   width: 180px !important;
  // }
`;
const StyledButton = styled(Button)`
  width: 120px;
  border: 1px solid ${COLORS.PRIMARY};
  color: ${COLORS.PRIMARY};
  width: initial;
  background: transparent;
  border-radius: 5px;
`;
const StyledButtonoutlined = styled(ButtonOutlined)`
  @media (max-width: 900px) {
    margin-left: -20px !important;
  }
  @media (max-width: 768px) {
    margin-left: -20px !important;
    margin-top: -1px !important;
  }
  @media (max-width: 575px) {
    margin-left: 0 !important;
    position: absolute;
    left: 0;
    margin-top: -1px;
  }
`;
function Approval({
  userRoleId,
  allDepartmentList,
  selectedDepartmentId,
  ClientId,
  userList,
  menuList,
  userInfo,
}) {
  console.log("userInfo--->>", userInfo);
  const [displayTableLoader, setDisplayTableLoader] = useState(false);
  const [attendanceList, setAttendanceList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [employeeFilterList, setEmployeeFilterList] = useState([]);
  const [form] = Form.useForm();
  const [filterList, setFilterList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const containerRef = useRef(null);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [countryFilterList, setCountryFilterList] = useState([]);
  const [filteredUserIds, setFilteredUserIds] = useState([]);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [getFilterData, setGetFilterData] = useState([]);

  const [scrollY, setScrollY] = useState();
  useEffect(() => {
    const calculateScrollY = () => {
      // const screenHeight = window.innerHeight;
      // const offset = 180; // Adjust this value as needed for headers/footers
      const dynamicHeight = window.innerHeight - 280;
      setScrollY(dynamicHeight);
    };
    calculateScrollY();
    window.addEventListener("resize", calculateScrollY);
    return () => window.removeEventListener("resize", calculateScrollY);
  }, [scrollY]);
  console.log("selectedCountries--->", selectedCountries);
  const curr_month = moment().month() + 1;
  const Menulist = menuList[userRoleId] || Object?.values(menuList)[0];
  const list = () => {
    let month_list = [];
    for (let i = 0; i < curr_month; i++) {
      month_list.push(MONTH_LIST[i]);
    }
    setMonthList(month_list);
  };
  console.log("attendanceList-->", attendanceList);
  const STAFF_LIST_ALL = attendanceList.map((val) => {
    return { user_id: val.userid, name: val.fullname };
  });

  for (let i = 0; i < STAFF_LIST_ALL.length; i++) {
    filterList.push(STAFF_LIST_ALL[i]);
  }

  const STAFF_LIST = uniqBy(
    attendanceList.map((val) => {
      return { user_id: val.userid, name: val.fullname };
    }),
    "user_id"
  );

  const filterattentancereport = attendanceList.filter((val) => {
    if (form.getFieldValue("employee")?.length === 0) {
      return val;
    } else if (form.getFieldValue("employee")?.includes(val?.userid)) {
      return val;
    }
  });
  console.log("filterattentancereport--->", form.getFieldValue("employee"));

  console.log("attendanceList-->", attendanceList);
  const handleCountryFilterChange = () => {
    const values = form.getFieldsValue();
    setFilteredCountries(values.country || []);
  };
  console.log("userList--->", userList);
  const applyFilters = () => {
    const selectedEmployeeIds = form.getFieldValue("employee") || [];
    const selectedCountries = form.getFieldValue("country") || [];
    const selectedDepartment = form.getFieldValue("department") || "";

    const filteredData = attendanceList.filter((val) => {
      // Employee filter
      const employeeMatch =
        selectedEmployeeIds.length === 0 ||
        selectedEmployeeIds.includes(val.userid);

      // Country filter
      const countryMatch =
        selectedCountries.length === 0 ||
        selectedCountries.includes(
          userList.find((user) => user.userid === val.userid)?.nationality
        );

      // Department filter
      const departmentMatch =
        selectedDepartment === "" ||
        userList
          .find((user) => user.userid === val.userid)
          ?.userdepartmentid?.includes(selectedDepartment);

      return employeeMatch && countryMatch && departmentMatch;
    });

    setCountryFilterList(filteredData); // Update the filtered list
  };
  useEffect(() => {
    applyFilters();
  }, [
    form.getFieldValue("employee"),
    form.getFieldValue("country"),
    form.getFieldValue("department"),
    attendanceList,
    userList,
  ]);

  // Update the table's data source

  useEffect(() => {
    if (filteredUserIds.length > 0) {
      // getAttendanceReport();
    }
  }, [filteredUserIds]);

  const countryList = userList
    .filter((user) =>
      attendanceList.some((attendance) => attendance.userid === user.userid)
    )
    .map((user) => user.nationality);

  console.log(countryList);

  console.log("countryList-->", countryList);

  // useEffect(() => {
  //   const filteredUsers = userList.filter(user =>
  //     filteredCountries.some(country => user.country === country)
  //   );
  //   const userIds = filteredUsers.map(user => user.userId);
  //   setFilteredUserIds(userIds);
  // }, [filteredCountries]);

  // useEffect(() => {
  //   let result;
  //   if (selectedCountries && selectedCountries.length > 0) {
  //     result = attendanceList?.filter((data) =>
  //       selectedCountries.includes(data?.nationality)
  //     );
  //   } else {
  //     result = attendanceList;
  //   }
  //   setCountryFilterList(result);
  // }, [selectedCountries, attendanceList]);

  // useEffect(() => {
  //   let result = countryFilterList;

  //   if (selectedStaff && selectedStaff.length > 0) {
  //     result = result.filter((data) => selectedStaff.includes(data?.userid));
  //   }

  //   setEmployeeFilterList(result);
  // }, [selectedStaff, countryFilterList]);

  const handleEmployeeFilterChange = () => {
    const values = form.getFieldsValue();
    setSelectedStaff(values.employee || []);
  };

  const uniqueEmployeeName = uniqBy(
    STAFF_LIST?.map((item) => {
      return {
        label: item.name,
        value: item.user_id,
      };
    }),
    "value"
  );

  const uniqueCountryName = uniqBy(
    countryList?.map((item) => {
      return {
        label: item,
        value: item,
      };
    }),
    "value"
  );

  const computeMinutes = (record) => {
    if (!record?.checkintime || !record?.checkouttime) return 0;

    const checkIn = dayjs(
      `${dayjs(record.checkindate).format("YYYY-MM-DD")} ${record.checkintime}`
    );

    const checkOut = dayjs(
      `${dayjs(record.checkoutdate || record.checkindate).format(
        "YYYY-MM-DD"
      )} ${record.checkouttime}`
    );

    let diffMinutes = checkOut.diff(checkIn, "minute");

    if (diffMinutes < 0) diffMinutes += 24 * 60;

    return diffMinutes;
  };

  const formatDuration = (minutes) => {
    const hrs = Math.floor(minutes / 60)
      .toString()
      .padStart(2, "0");
    const mins = (minutes % 60).toString().padStart(2, "0");
    return `${hrs}:${mins}`;
  };

  const columns = [
    {
      title: "Employee ID",
      dataIndex: "employeeid",
      key: "employeeid",
      width: 130,
    },
    {
      title: "Employee Name",
      dataIndex: "fullname",
      key: "fullname",
      width: 200,
      render: (fullName) => {
        if (fullName !== ("" || null || undefined)) {
          return fullName;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Department",
      dataIndex: "departmentname",
      key: "departmentname",
      width: 180,
      render: (departmentName) => {
        if (departmentName !== ("" || null || undefined)) {
          return departmentName;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Checkin Station",
      dataIndex: "loginlocationname",
      key: "loginlocationname",
      width: 200,
      render: (loginlocationname) => {
        if (loginlocationname !== ("" || null || undefined)) {
          return loginlocationname;
        } else {
          return "-";
        }
      },
    },
    {
      title: "Checkout Type",
      dataIndex: "checkouttype",
      key: "checkouttype",
      width: 150,
      align: "center",
      render: (checkouttype) =>
        checkouttype === null || checkouttype === undefined || checkouttype === ""
          ? "-"
          : checkouttype,
    },
    {
      title: "Check-in date",
      dataIndex: "checkindate",
      key: "checkindate",
      width: 150,
      render: (checkinDate) => {
        if (checkinDate === ("" || null || undefined)) return "-";
        const checkinDateFormat = moment(checkinDate).format("DD MMM YYYY");
        return `${checkinDateFormat}`;
      },
    },
    {
      title: "Check-in day",
      dataIndex: "checkindate",
      key: "checkindate",
      width: 150,
      render: (checkinDate) => {
        if (checkinDate === ("" || null || undefined)) return "-";
        const getdayAlone = moment(checkinDate).format("dddd");
        return `${getdayAlone}`;
      },
    },
    {
      title: "Check-in time",
      dataIndex: "checkintime",
      key: "checkintime",
      width: 150,
    },
    {
      title: "Check-in Coordinates",
      dataIndex: "loginlatitude",
      key: "loginlatitude",
      width: 240,
      render: (_, record) => {
        const url1 =
          "http://maps.google.com/maps/?q=" +
          record.loginlatitude +
          "," +
          record.loginlongitude +
          "";
        return (
          <div>
            {record.loginlatitude !== ("" || null || undefined) &&
            record.loginlongitude !== ("" || null || undefined) ? (
              <>
                <div id="loc">
                  <a href={url1} target="_blank">
                    {record.loginlatitude},{record.loginlongitude}
                  </a>
                </div>
              </>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Checkout Station",
      dataIndex: "logoutlocationname",
      key: "logoutlocationname",
      width: 200,
      render: (logoutLocationName) => {
        if (
          logoutLocationName === null ||
          logoutLocationName === "" ||
          logoutLocationName === undefined
        ) {
          return "-";
        } else {
          return logoutLocationName;
        }
      },
    },
    {
      title: "Check-out date",
      dataIndex: "checkoutdate",
      key: "checkoutdate",
      width: 150,
      render: (checkoutDate) => {
        if (
          checkoutDate === null ||
          checkoutDate === "" ||
          checkoutDate === undefined
        ) {
          return "-";
        } else {
          const dateFormat = moment(checkoutDate).format("DD MMM YYYY");
          return `${dateFormat}`;
        }
      },
    },
    {
      title: "Check-out day",
      dataIndex: "checkoutdate",
      key: "checkoutdate",
      width: 150,
      render: (checkoutDate) => {
        if (
          checkoutDate === null ||
          checkoutDate === "" ||
          checkoutDate === undefined
        ) {
          return "-";
        } else {
          const getdayAlone = moment(checkoutDate).format("dddd");
          return `${getdayAlone}`;
        }
      },
    },
    {
      title: "Check-out time",
      dataIndex: "checkouttime",
      key: "checkouttime",
      width: 150,
      render: (checkoutDateTime) => {
        if (
          checkoutDateTime === null ||
          checkoutDateTime === "" ||
          checkoutDateTime === undefined
        ) {
          return "-";
        } else {
          // const { time24 } = dateInDetail(checkoutDateTime);
          return checkoutDateTime;
        }
      },
    },
    {
      title: "Check-out Coordinates",
      dataIndex: "end_lat_long",
      key: "logoutlatitude",
      width: 240,
      render: (_, record) => {
        const url =
          "http://maps.google.com/maps/?q=" +
          record.logoutlatitude +
          "," +
          record.logoutlongitude +
          "";
        return (
          <div>
            {record.logoutlatitude === null ||
            record.logoutlatitude === "" ||
            (record.logoutlatitude === undefined &&
              record.logoutlongitude === null) ||
            record.logoutlongitude === "" ||
            record.logoutlongitude === undefined ? (
              "-"
            ) : (
              <>
                <div>
                  <a href={url} target="_blank">
                    {record.logoutlatitude},{record.logoutlongitude}
                  </a>
                </div>
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Total Work Duration",
      key: "totalworkedhours",
      width: 220,
      render: (_, record) => {
        if (!record?.checkintime || !record?.checkouttime) {
          return "00:00";
        }

        // create full datetime using checkindate + time
        const checkIn = dayjs(
          `${dayjs(record.checkindate).format("YYYY-MM-DD")} ${
            record.checkintime
          }`
        );

        const checkOut = dayjs(
          `${dayjs(record.checkoutdate || record.checkindate).format(
            "YYYY-MM-DD"
          )} ${record.checkouttime}`
        );

        let diffMinutes = checkOut.diff(checkIn, "minute");

        // handle overnight shift
        if (diffMinutes < 0) {
          diffMinutes += 24 * 60;
        }

        const hours = Math.floor(diffMinutes / 60)
          .toString()
          .padStart(2, "0");

        const minutes = (diffMinutes % 60).toString().padStart(2, "0");

        return `${hours}:${minutes}`;
      },
    },
  ];

  useEffect(() => {
    getAttendanceReport();
  }, [
    selectedCountries,
    userRoleId,
    form.getFieldValue("duration_type"),
    form.getFieldValue("start_date"),
    form.getFieldValue("end_date"),
    form.getFieldValue("month"),
    form.getFieldValue("department"),
  ]);
  const isChairman = userInfo.higherOfficialsList.some(
    (official) => official.role === "CEO" && official.email === userInfo.userid
  );
  const getAttendanceReport = async () => {
    list();
    return new Promise(async (resolve, reject) => {
      setAttendanceList([]);
      const { start_date, end_date, duration_type, month } =
        form.getFieldsValue();
      setDisplayTableLoader(true);
      const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
        dateInDetail(getKenyanDateTime()).year,
        get(find(MONTH_LIST, { value: month }), "index", 0)
      );
      const emailList = userInfo.higherOfficialsList.map((official) =>
        official.email.toLowerCase()
      );
      const isPrivilegedUser = emailList.includes(
        userInfo.userid.toLowerCase()
      );

      const payload = {
        department: [""],
        start_date: getMySqlDate(
          duration_type === 2 ? startDateOfMonth : start_date
        ),
        end_date: getMySqlDate(
          duration_type === 2 ? lastDateOfMonth : end_date
        ),
        reportingmanager: isChairman
          ? ""
          : isPrivilegedUser
          ? ""
          : userInfo?.userid,
        userIds: isChairman ? [] : isPrivilegedUser ? userId : filteredUserIds,
      };

      console.log("Payload before API call:", payload);
      const { code, attendanceList = [] } = await CALL_API(
        `attendance-report/${ClientId}`,
        "post",
        payload
      );
      setDisplayTableLoader(false);
      if (includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)) {
        setAttendanceList(orderBy(attendanceList, ["checkindate"], ["desc"]));
      }
    });
  };

  const validateDateRange = (date) => {
    const endDate = moment(form.getFieldValue("end_date"));
    if (endDate < date) {
      form.setFieldsValue({ end_date: date });
    }
  };

  const xport = React.useCallback(() => {
    const data =
      countryFilterList.length > 0 ? countryFilterList : attendanceList;

    const headers = [
      "Employee ID",
      "Employee Name",
      "Department",
      "Checkin Station",
      "Checkout Type",
      "Check-in date",
      "Check-in day",
      "Check-in time",
      "Check-in Coordinates",
      "Checkout Station",
      "Check-out date",
      "Check-out day",
      "Check-out time",
      "Check-out Coordinates",
      "Total Work Duration",
    ];

    const rows = data.map((record) => ({
      "Employee ID": record.employeeid || "",
      "Employee Name": record.fullname || "",
      Department: record.departmentname || "",
      "Checkin Station": record.loginlocationname || "",
      "Checkout Type": record.checkouttype || "",
      "Check-in date": record.checkindate
        ? moment(record.checkindate).format("DD MMM YYYY")
        : "",
      "Check-in day": record.checkindate
        ? moment(record.checkindate).format("dddd")
        : "",
      "Check-in time": record.checkintime || "",
      "Check-in Coordinates":
        record.loginlatitude || record.loginlongitude
          ? `${record.loginlatitude || ""},${record.loginlongitude || ""}`
          : "",
      "Checkout Station": record.logoutlocationname || "",
      "Check-out date": record.checkoutdate
        ? moment(record.checkoutdate).format("DD MMM YYYY")
        : "",
      "Check-out day": record.checkoutdate
        ? moment(record.checkoutdate).format("dddd")
        : "",
      "Check-out time": record.checkouttime || "",
      "Check-out Coordinates":
        record.logoutlatitude || record.logoutlongitude
          ? `${record.logoutlatitude || ""},${record.logoutlongitude || ""}`
          : "",
      "Total Work Duration": formatDuration(computeMinutes(record)),
    }));

    const totalMinutes = data.reduce(
      (sum, rec) => sum + computeMinutes(rec),
      0
    );

    // Append a summary row
    rows.push({
      "Employee ID": "Total Work Duration",
      "Employee Name": "",
      Department: "",
      "Checkin Station": "",
      "Checkout Type": "",
      "Check-in date": "",
      "Check-in day": "",
      "Check-in time": "",
      "Check-in Coordinates": "",
      "Checkout Station": "",
      "Check-out date": "",
      "Check-out day": "",
      "Check-out time": "",
      "Check-out Coordinates": "",
      "Total Work Duration": formatDuration(totalMinutes),
    });

    const ws = utils.json_to_sheet(rows, { header: headers });
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Attendance");
    writeFileXLSX(wb, "attendance-report.xlsx");
  }, [attendanceList, countryFilterList, computeMinutes, formatDuration]);

  const paginationOptions = {
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    pageSize: 100,
    showSizeChanger: false,
  };

  const finduser = userList?.find((val) => val?.userid === userInfo?.userid);
  const nationality = finduser?.nationality;
  const userId = userList
    .filter((user) => user.nationality?.includes(nationality))
    .map((user) => user.userid);

  return (
    <>
      <Row className="page-title">
        <Col
          xs={24}
          sm={19}
          md={19}
          className="page-title-head"
          ref={containerRef}
        >
          <Space>
            <StyledApprovalSearchForm
              form={form}
              name="approval_form"
              layout="inline"
              initialValues={{
                staff_name: "",
                duration_type: 2,
                month: dateInDetail(getKenyanDateTime()).monthName,
                start_date: momentDate(addMonthinDate(getKenyanDateTime(), -1)),
                end_date: momentDate(addDaysinDate(getKenyanDateTime())),
                department: "",
                employee: [],
                country: [],
              }}
              onFinish={getAttendanceReport}
              onValuesChange={(changedValues) => {
                handleEmployeeFilterChange();
                handleCountryFilterChange();
                if (changedValues.country) {
                  console.log("changedValues--->", changedValues);
                  getAttendanceReport();
                }
              }}
            >
              <Form.Item
                name="duration_type"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Select
                  className="custom_form_design"
                  placeholder="Select..."
                  options={REPORT_DURATION_TYPES}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>

              <Form.Item className="outer-form" shouldUpdate>
                {({ getFieldValue }) => {
                  const duration_type = getFieldValue("duration_type");
                  return duration_type === 1 ? (
                    <>
                      <Form.Item
                        name="start_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="Start date"
                          format="DD-MM-YYYY"
                          style={{ borderRadius: "20px" }}
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>

                      <Form.Item
                        name="end_date"
                        rules={[
                          () => ({
                            validator(rule, value) {
                              const date = moment(value);
                              return date.isValid()
                                ? Promise.resolve()
                                : Promise.reject();
                            },
                          }),
                        ]}
                      >
                        <DatePicker
                          placeholder="End date"
                          format="DD-MM-YYYY"
                          style={{ borderRadius: "20px" }}
                          onChange={validateDateRange}
                          allowClear={false}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item
                        name="month"
                        rules={[
                          {
                            required: true,
                            message: "",
                          },
                        ]}
                      >
                        <Select
                          className="custom_form_design"
                          style={{ width: "160px" }}
                          placeholder="Select..."
                          options={monthList}
                          getPopupContainer={() => containerRef.current}
                        />
                      </Form.Item>
                    </>
                  );
                }}
              </Form.Item>
              <Form.Item
                name="staff_name"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                {/* <Select
                  className="custom_form_design"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.name ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.name ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.name ?? "").toLowerCase())
                  }
                  placeholder="Select Employee"
                  options={concat(
                    {
                      user_id: "",
                      name: "All Employee",
                    },
                    STAFF_LIST
                  )}
                  fieldNames={{
                    label: "name",
                    value: "user_id",
                  }}
                  getPopupContainer={() => containerRef.current}
                /> */}
              </Form.Item>
              <Form.Item
                name="employee"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                <DropdownCheckBox
                  name="employee"
                  label="All Employee"
                  options={uniqueEmployeeName}
                  form={form}
                  handleFormChange={handleEmployeeFilterChange}
                />
              </Form.Item>

              {
                // Menulist?.find(
                //   (item) =>
                //     item?.key === "countryfilter" &&
                //     item?.permission.view
                // )
                isChairman && (
                  <Form.Item name="country">
                    <DropdownCheckBox
                      name="country"
                      label="Country"
                      options={uniqueCountryName}
                      form={form}
                      clearFunction={getAttendanceReport}
                      handleFormChange={handleCountryFilterChange}
                      className="custom_form_design"
                    />
                  </Form.Item>
                )
              }
              {(userRoleId === 1 || userRoleId === 6) && (
                <Form.Item name="department">
                  <Select
                    placeholder="Select Department"
                    options={concat(
                      {
                        department_id: "",
                        department_name: "All Departments",
                      },
                      allDepartmentList
                    )}
                    fieldNames={{
                      label: "department_name",
                      value: "department_id",
                    }}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </StyledApprovalSearchForm>
          </Space>
        </Col>
        <Col xs={24} sm={4} md={4} className="align-right">
          <StyledButtonoutlined
            onClick={xport}
            disabled={
              countryFilterList.length > 0
                ? attendanceList?.length === 0
                : countryFilterList?.length === 0
            }
          >
            Export XLSX file
          </StyledButtonoutlined>
        </Col>
      </Row>
      <br />
      <Spin spinning={displayTableLoader}>
        <StyledTable
          dataSource={
            countryFilterList.length > 0 ? countryFilterList : attendanceList
          }
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          scroll={{ y: scrollY }}
          pagination={
            countryFilterList.length > 100 ? paginationOptions : false
          }
          summary={() => {
            const data =
              countryFilterList.length > 0 ? countryFilterList : attendanceList;
            const totalMinutes = data.reduce(
              (sum, rec) => sum + computeMinutes(rec),
              0
            );
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={columns.length - 1}>
                  Total Work Duration
                </Table.Summary.Cell>
                <Table.Summary.Cell index={columns.length - 1}>
                  {formatDuration(totalMinutes)}
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
          id="Table"
        />
        {/* <Table
          style={{ display: "none" }}
          dataSource={filterattentancereport}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          pagination={false}
          id="Table"
        /> */}
      </Spin>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  userList: getUserList(state),
  allDepartmentList: getAllDepartmentList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  shiftTimeMaster: getShiftTimeMaster(state),
  ClientId: getClientid(state),
  userInfo: getUserInfo(state),
  menuList: getMenuList(state),
});

export default connect(mapStateToProps, null)(Approval);
